/*eslint-disable*/
import { useState, useMemo, useEffect } from "react";
import { toast } from 'react-toastify'

// services
import { fetchAuthenticatorEnrollments } from '../../../../services/user';

const getAuthenticatorEnrollmentOptions = (authenticatorEnrollments=[]) => {
  return authenticatorEnrollments.filter(enrollment => enrollment.key !== "okta_password" && enrollment.key !== "okta_email").map(enrollment => ({
    label: enrollment.name,
    value: enrollment.key,
    factorId: enrollment.id,
  }))
}

const useAuthenticatorEnrollments = (userId) => {
    const [authenticatorEnrollments, setAuthenticatorEnrollments] = useState([]);
    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {
        getAuthenticatorEnrollments()
    }, [])
    const getAuthenticatorEnrollments = async () => {
        try {
          const response = await fetchAuthenticatorEnrollments(userId)
          const allAuthenticatorEnrollments = response?.data?.resources
          setAuthenticatorEnrollments(allAuthenticatorEnrollments)
          setIsLoading(false)
        } catch (error) {
          toast.error(error.message)
          setIsLoading(false)
        }
      }

    const authenticatorEnrollmentOptions = useMemo(() => 
        getAuthenticatorEnrollmentOptions(authenticatorEnrollments), 
    [authenticatorEnrollments])

    return {
        authenticatorEnrollments, 
        areAuthenticatorEnrollmentsLoading: isLoading,
        authenticatorEnrollmentOptions 
    };
}

export default useAuthenticatorEnrollments;